import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import wrapWithProviders from 'utils/wrapWithProviders';
import { enableAPIMocking } from 'utils/mswUtils';
enableAPIMocking;
const root = ReactDOM.createRoot(document.getElementById('root'));

enableAPIMocking().then(() => {
    root.render(wrapWithProviders(<App />, { environment: 'live' }));
});
